import { Injectable } from '@angular/core';

@Injectable()
export class RandomStringGeneratorProvider {
	constructor() {}

	getMixedString = (numberOfCharacters = 8): string =>
		Math.random()
			.toString(36)
			.substr(2, numberOfCharacters);
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/helpers/random-string-generator.ts